import Settings from "../../utils/CarrotConfig"
import { SupportCenterLinks } from "../../utils/SupportCenterLinks"
import { isMobileApp } from "./MobileNativeClient"
import { MouseEvent } from "react"

const HelpCenterBaseUri = Settings.ZENDESK_GUIDE

const parseZendeskFragmentFromUrl = (url: string) => {
  const urlPathname = new URL(url).pathname
  if (urlPathname === "/hc" || urlPathname === "/hc/") return null
  const filteredUrl = urlPathname?.split("/").filter((path) => path !== "hc" && path !== "")
  return filteredUrl.join("/")
}

// Native previously opened the Help Center via a `showZendesk` bridge call,
// which bypassed the Zendesk redirect layer and broke after the in-app Help
// Center migration. Instead, navigate the webview to the Zendesk deep link
// (same URL the web side uses); the redirect layer forwards it to the matching
// in-app article. Same-tab navigation keeps the member inside the app.
const goToHelpCenter = async (event: MouseEvent<HTMLElement>, link?: string) => {
  if (isMobileApp()) {
    event.preventDefault()
    window.location.assign(getHelpCenterLink(link))
  }
}

const goToHelpCenterLegacy = async (link?: SupportCenterLinks) => {
  if (isMobileApp()) {
    window.location.assign(getHelpCenterLink(link))
  } else {
    window.open(getHelpCenterLink(link), "_blank")
  }
}

const getHelpCenterLink = (link?: string) => {
  return isNullOrUndefined(link) ? HelpCenterBaseUri : `${HelpCenterBaseUri}/${link}`
}

const isNullOrUndefined = (link: any) => {
  return typeof link === "undefined" || link == null
}

const isZendeskLink = (href: any) => {
  try {
    const url = new URL(href)
    return url?.host?.match(/\.*\.zendesk\.com/)
  } catch (e) {
    return false
  }
}

const getLocalizedZendeskLink = (link: string, zendeskLocale: string): string => {
  const linkWithoutLocale = link.replace(/\/en-us/i, "")
  return linkWithoutLocale.replace("hc", `hc/${zendeskLocale}`)
}

export {
  goToHelpCenterLegacy,
  goToHelpCenter,
  getHelpCenterLink,
  isZendeskLink,
  parseZendeskFragmentFromUrl,
  getLocalizedZendeskLink
}
